import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";

export const CUSTOMER_CARD_STEPS = [
  { key: "organization", messageId: "admin.crm.customerCard.steps.customer", icon: BusinessOutlinedIcon },
  { key: "addresses", messageId: "admin.crm.customerCard.steps.addresses", icon: LocationOnOutlinedIcon },
  { key: "billing", messageId: "admin.crm.customerCard.steps.billing", icon: PaymentsOutlinedIcon },
  { key: "review", messageId: "admin.crm.customerCard.steps.review", icon: CheckCircleOutlineRoundedIcon },
];
